var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('p',{staticClass:"tips1"},[_vm._v("404")])]),_c('div',[_c('p',{staticClass:"tips2"},[_vm._v("你访问的页面丢失了！")])])])
}]

export { render, staticRenderFns }